export default __webpack_public_path__ + "static/media/right_sidebar_arrow_active.c2f6d86c.svg";